import { z } from 'zod';
import { DealActivityStatus, DealActivityEventType, DealActivityEventPriority } from '@trnsact/trnsact-shared-types';

import { dateStringSchema } from '../../../model';

const timeStringSchema = z.string().nullable();

export const calendarEventUpdateFormSchema = z
  .object({
    subject: z.string().min(1, 'Subject is required'),
    accountId: z.string().uuid(),
    allDay: z.boolean(),
    description: z.string(),
    startDate: dateStringSchema,
    endDate: dateStringSchema,
    startTime: timeStringSchema,
    endTime: timeStringSchema,
    eventType: z.nativeEnum(DealActivityEventType),
    activityStatus: z.nativeEnum(DealActivityStatus),
    priority: z.nativeEnum(DealActivityEventPriority),
  })
  .superRefine((data, ctx) => {
    if (!data.startDate) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Start date is required', path: ['startDate'] });
    }

    if (!data.endDate) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End date is required', path: ['endDate'] });
    }

    if (!data.allDay) {
      if (!data.startTime) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Start time is required', path: ['startTime'] });
      }

      if (!data.endTime) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End time is required', path: ['endTime'] });
      }
    }

    if (data.allDay && data.startDate && data.endDate && new Date(data.endDate) < new Date(data.startDate)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End date must be after start date', path: ['endDate'] });
    }
  });

export type CalendarEventUpdateFormValues = z.infer<typeof calendarEventUpdateFormSchema>;
